import { assoc, compose, map, pathOr, pick } from 'ramda'
import { gql, useMutation } from '@apollo/client'
import { useNotification } from '@btime/react-messager'

import { compliancesClient, serviceOrdersClient } from '../../../../utils/apollo/api'
import { formatApiDate } from '../../../../utils/helpers/date'
import { useMoveBack } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertServiceOrder($input: ServiceOrderInput) {
    upsertServiceOrder(input: $input) {
      id
    }
  }
`

const cleanEvents = serviceOrder => {
  if (!!serviceOrder.id) return serviceOrder
  return assoc('events', [{ statusId: 1, eventDate: formatApiDate(new Date()) }], serviceOrder)
}

const cleanRequest = compose(
  pick([
    'id',
    'userId',
    'checklistId',
    'placeId',
    'scheduling',
    'description',
    'documents',
    'groupId',
    'events',
    'nonComplianceId',
    'type'
  ]),

  item => assoc('scheduling', formatApiDate(item.scheduling), item),
  item => assoc('type', 'actionPlan', item),
  item => assoc('documents', map(pick(['id', 'description']), item.documents || []), item),
  item => assoc('description', item.description || '', item),
  item => assoc('checklistId', item.checklistId || item.checklist?.id, item),
  item => assoc('userId', pathOr(null, ['user', 'id'], item), item),
  item => assoc('groupId', pathOr(null, ['group', 'id'], item), item),
  cleanEvents
)

export const useSaveActionPlan = () => {
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['NonCompliances'],
    client: serviceOrdersClient
  })

  const goBack = useMoveBack()
  const notify = useNotification()

  const handleRequest = data => {
    const input = cleanRequest(data)
    return request({ variables: { input } }).then(resp => {
      if (!resp.errors) {
        compliancesClient.reFetchObservableQueries()
        if (goBack) goBack()
      } else {
        notify.error({ title: 'Ocorreu um erro ao completar!' })
      }
    })
  }

  return [handleRequest, state]
}
